export enum Credits {
  TEN = 'TEN',
  TWENTY = 'TWENTY',
  FIFTY = 'FIFTY',
}
